import Lottie from 'lottie-react'
import animationData from '../assets/WebEateryAnimatedLogo.json'

interface LoadingScreenProps {
  /** Error message to display with retry button */
  error?: string | null
  /** Called when user clicks retry */
  onRetry?: () => void
}

/**
 * This screen renders before tenant theming resolves, so it has no design
 * tokens to read from. Fall back to the OS preference so dark-mode users
 * don't get a full-viewport white flash on boot. Mirrors the <html>
 * background rule in index.html.
 */
const isDark =
  typeof window !== 'undefined' &&
  window.matchMedia?.('(prefers-color-scheme: dark)').matches === true

const colors = isDark
  ? { background: '#000000', text: '#999999', buttonBackground: '#EEEEEE', buttonText: '#111111' }
  : { background: '#FFFFFF', text: '#666666', buttonBackground: '#333333', buttonText: '#FFFFFF' }

export function LoadingScreen({ error, onRetry }: LoadingScreenProps) {
  if (error) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: colors.background,
        fontFamily: 'system-ui, sans-serif',
        gap: '16px',
      }}>
        <p style={{ color: colors.text, fontSize: '16px' }}>Something went wrong, please try again</p>
        {onRetry && (
          <button
            onClick={onRetry}
            style={{
              padding: '10px 24px',
              fontSize: '14px',
              backgroundColor: colors.buttonBackground,
              color: colors.buttonText,
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
            }}
          >
            Retry
          </button>
        )}
      </div>
    )
  }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: colors.background,
    }}>
      <Lottie
        animationData={animationData}
        loop={false}
        style={{ width: 100, height: 100 }}
      />
    </div>
  )
}
